import IMask from 'imask';

// masks for phone inputs
var inputsPhone = document.querySelectorAll('[type=tel]');
var phoneMask = {
    mask: '(000) 000-0000'
};

var inputsEmail = document.querySelectorAll('[type=email]');
var emailMask = {
  mask: 'w@w.w',
  blocks: {
    w: { mask: /\w*/g }
  }
};

for (var i = 0; i < inputsPhone.length; i++) {
    IMask(inputsPhone[i], phoneMask);
}

for (var i = 0; i < inputsEmail.length; i++) {
    IMask(inputsEmail[i], emailMask);
}
